(() => {
  const form = document.getElementById('pbp-style-quiz-form');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const root = window.Shopify?.routes?.root || '/';
  const params = new URLSearchParams(location.search);
  const controls = [...form.elements];
  const tiers = controls.filter(el => el.name === 'tier');
  const variants = tiers.map(el => el.value);
  const fields = document.getElementById('pbp-profile-fields');
  const message = document.getElementById('pbp-message');
  const saved = document.getElementById('pbp-saved');
  const saveButton = document.getElementById('pbp-save');
  const checkout = document.getElementById('pbp-checkout');
  const returning = document.getElementById('pbp-returning');
  const iconGroup = form.querySelector('[data-style-icons]');
  const icons = [...iconGroup.querySelectorAll('input[type="checkbox"]')];
  const iconFeedback = document.getElementById('pbp-icons-feedback');
  const iconDraftKey = 'pbp-style-icons-v2';
  let iconDraft = null;
  try {
    const storedIcons = JSON.parse(sessionStorage.getItem(iconDraftKey));
    if (Array.isArray(storedIcons)) iconDraft = storedIcons;
  } catch {}
  function selectedIcons() { return icons.filter(icon => icon.checked); }
  function showIcons(text) {
    icons.forEach(icon => icon.closest('label').classList.toggle('is-selected', icon.checked));
    iconFeedback.textContent = text || (icons.some(icon => icon.checked && icon.hasAttribute('data-icon-none')) ? 'None of these selected.' : selectedIcons().length + ' of 2 selected.');
  }
  function restoreIcons() {
    if (iconDraft !== null) icons.forEach(icon => { icon.checked = iconDraft.includes(icon.value); });
    const active = selectedIcons();
    if (active.length > 2 || (active.length > 1 && active.some(icon => icon.hasAttribute('data-icon-none')))) {
      icons.forEach(icon => { icon.checked = false; });
    }
    showIcons();
  }
  function saveIconDraft() {
    iconDraft = selectedIcons().map(icon => icon.value);
    try { sessionStorage.setItem(iconDraftKey, JSON.stringify(iconDraft)); } catch {}
  }
  iconGroup.addEventListener('change', event => {
    const icon = event.target;
    if (!icons.includes(icon)) return;
    let feedback = '';
    if (icon.checked && icon.hasAttribute('data-icon-none')) {
      icons.forEach(other => { if (other !== icon) other.checked = false; });
    } else if (icon.checked) {
      icons.find(other => other.hasAttribute('data-icon-none')).checked = false;
      if (selectedIcons().length > 2) {
        icon.checked = false;
        feedback = 'You can choose up to 2 style icons. Deselect one to choose another.';
      }
    }
    icons[0].setCustomValidity('');
    saveIconDraft();
    showIcons(feedback);
  });
  window.addEventListener('pageshow', restoreIcons);
  let busy = false;
  let savedSnapshot = null;
  let targetKey = params.get('line');
  let attemptId = crypto.randomUUID();
  let revision = 0;
  const selected = () => tiers.find(el => el.checked);
  const isEdit = item => variants.includes(String(item.variant_id));
  const complete = item => item.properties?._pbp_complete === 'yes' && item.properties?._pbp_schema === '1' && item.properties?.['_PBP Name'] && item.properties?.['_PBP Email'];
  function notify(text) { message.textContent = text; }
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    if (!response.ok) throw new Error('We could not save your profile. Your answers are still here. Please try again.');
    return response.json();
  }
  function collect() {
    const data = new FormData(form);
    const properties = { _pbp_schema: '1', _pbp_complete: 'yes', _pbp_id: attemptId, 'Style Profile': 'Completed', '_PBP Tier': selected().dataset.title };
    for (const name of new Set(data.keys())) {
      if (name !== 'tier') properties['_PBP ' + name] = JSON.stringify(data.getAll(name).map(value => String(value).trim()));
    }
    return properties;
  }
  function prefill(properties) {
    if (Array.isArray(properties)) properties = Object.fromEntries(properties);
    if (!properties || properties._pbp_schema !== '1') return false;
    for (const control of controls) {
      if (!control.name || control.name === 'tier' || control.name === 'Final sale acknowledgement') continue;
      const stored = properties['_PBP ' + control.name];
      if (stored == null) continue;
      let values;
      try { values = JSON.parse(stored); } catch { values = [stored]; }
      if (!Array.isArray(values)) values = [String(values)];
      if (control.type === 'checkbox') control.checked = values.includes(control.value);
      else control.value = values[0] || '';
    }
    returning.hidden = false;
    restoreIcons();
    const firstName = form.querySelector('[name="Name"]').value.trim().split(/\s+/)[0];
    returning.querySelector('h2').textContent = firstName ? 'Welcome back, ' + firstName : 'Welcome back';
    return true;
  }
  function validate() {
    for (const control of controls) {
      if (control.required && ['text', 'email', 'textarea'].includes(control.type)) {
        control.setCustomValidity(control.value.trim() ? '' : 'Please complete this question.');
      }
    }
    for (const group of form.querySelectorAll('[data-required-group]')) {
      const checkboxes = [...group.querySelectorAll('input[type="checkbox"]')];
      if (checkboxes.length) checkboxes[0].setCustomValidity(checkboxes.some(el => el.checked) ? '' : 'Please choose at least one answer.');
      if (group === iconGroup) {
        const active = selectedIcons();
        if (active.length > 2 || (active.length > 1 && active.some(icon => icon.hasAttribute('data-icon-none')))) {
          icons[0].setCustomValidity('Choose up to 2 style icons, or choose None of these on its own.');
        }
      }
    }
    return form.reportValidity();
  }
  function invalidate() { revision++; savedSnapshot = null; saved.hidden = true; }
  form.addEventListener('input', event => { event.target.setCustomValidity?.(''); invalidate(); });
  form.addEventListener('change', event => {
    invalidate();
    if (event.target.name === 'tier') {
      fields.hidden = false;
      // A line being edited must retain its selected product.
      if (targetKey) targetKey = null;
      attemptId = crypto.randomUUID();
    }
    const group = event.target.closest('[data-required-group]');
    group?.querySelector('input')?.setCustomValidity('');
    const unwanted = event.target.closest('[data-unwanted-items]');
    if (unwanted && event.target.checked) {
      if (event.target.hasAttribute('data-exclusive-none')) unwanted.querySelectorAll('input:not([data-exclusive-none])').forEach(el => { el.checked = false; });
      else unwanted.querySelector('[data-exclusive-none]').checked = false;
    }
  });
  document.getElementById('pbp-update').addEventListener('click', () => {
    returning.hidden = true;
    form.querySelector('[name="Age"]').focus();
  });
  document.getElementById('pbp-reuse').addEventListener('click', () => {
    notify('Review your saved preferences and confirm the final sale acknowledgement below.');
    form.querySelector('[name="Final sale acknowledgement"]').focus();
    form.requestSubmit();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !selected() || !validate()) return;
    busy = true; saveButton.disabled = true; invalidate(); notify('Saving your Style Profile…');
    const savingRevision = revision;
    try {
      const tier = selected().value;
      const properties = collect();
      const cart = await request('cart.js');
      let existing = cart.items.find(item => item.key === targetKey && String(item.variant_id) === tier);
      existing ||= cart.items.find(item => String(item.variant_id) === tier && item.properties?._pbp_id === attemptId);
      existing ||= cart.items.find(item => String(item.variant_id) === tier && !complete(item));
      if (existing) {
        await request('cart/change.js', { id: existing.key, quantity: existing.quantity, properties: { ...existing.properties, ...properties } });
      } else {
        await request('cart/add.js', { items: [{ id: Number(tier), quantity: 1, properties }] });
      }
      const verified = await request('cart.js');
      const item = verified.items.find(item => String(item.variant_id) === tier && item.properties?._pbp_id === attemptId);
      if (!item || !Object.entries(properties).every(([key, value]) => item.properties[key] === value)) {
        throw new Error('We could not confirm your saved answers. Please try saving again before checkout.');
      }
      targetKey = item.key;
      if (revision !== savingRevision) throw new Error('Your preferences changed while saving. Please save once more to include your latest answers.');
      savedSnapshot = { properties, tier };
      saved.hidden = false;
      notify('Your Style Profile is saved with your Edit.');
      checkout.focus();
    } catch (error) { notify(error.message || 'Unable to save. Please try again.'); message.focus(); }
    finally { busy = false; saveButton.disabled = false; }
  });
  checkout.addEventListener('click', async () => {
    if (busy || !savedSnapshot) return;
    busy = true; checkout.disabled = true;
    try {
      const cart = await request('cart.js');
      const item = cart.items.find(item => item.properties?._pbp_id === attemptId && String(item.variant_id) === savedSnapshot.tier);
      if (!item || !Object.entries(savedSnapshot.properties).every(([key, value]) => item.properties[key] === value)) {
        invalidate(); throw new Error('Your cart changed. Please save your Style Profile again.');
      }
      const missing = cart.items.find(item => isEdit(item) && !complete(item));
      if (missing) {
        location.assign(root + 'pages/style-quiz?tier=' + missing.variant_id + '&line=' + encodeURIComponent(missing.key));
      } else location.assign(root + 'checkout');
    } catch (error) { notify(error.message); }
    finally { busy = false; checkout.disabled = false; }
  });
  const requestedTier = tiers.find(el => el.value === params.get('tier') && !el.disabled);
  if (requestedTier) { requestedTier.checked = true; fields.hidden = false; }
  let prior;
  try { prior = JSON.parse(document.getElementById('pbp-saved-profile').textContent); } catch { prior = null; }
  prefill(prior);
  restoreIcons();
  const draftRevision = controls.map(el => el.value + ':' + el.checked).join('|');
  request('cart.js').then(cart => {
    // Never overwrite answers typed while the cart request was loading.
    if (draftRevision !== controls.map(el => el.value + ':' + el.checked).join('|')) return;
    const profile = cart.items.find(item => item.key === targetKey) || cart.items.find(item => isEdit(item) && complete(item));
    if (profile) prefill(profile.properties);
  }).catch(() => {});
})();
